<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="caption keep-spaces">
      <v-row no-gutters>
        <v-col cols="3">
          <v-icon small color="green">mdi-puzzle</v-icon>
          {{extension.displayName}}
          <span class="grey--text">[{{name}}]</span>
        </v-col>
        <v-col cols="9">
          <v-chip-group column>
            <div v-for="chip in chips" :key="chip.key">
              <v-tooltip bottom color="secondary">
                <template v-slot:activator="{ on }">
                  <v-chip :color="chip.color" v-on="on" small>
                    <v-avatar left>
                      <v-icon small>{{chip.icon}}</v-icon>
                    </v-avatar>
                    {{chip.name}}
                  </v-chip>
                </template>
                <span class="caption font-weight-bold">Type: {{chip.type}}</span>
                <Code v-if="chip.data" v-bind:code="chip.data" />
              </v-tooltip>
            </div>
          </v-chip-group>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <Code v-bind:code="extension" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Code from "../Code";

export default {
  name: "ExtensionsMain",
  props: ["extension", "name"],
  components: { Code },
  data() {
    return {
      chips: []
    };
  },
  methods: {
    getIcon(type) {
      if (type === "dataElements") {
        return "mdi-database";
      }
      if (type === "actions") {
        return "mdi-crosshairs";
      }
      if (type === "events") {
        return "mdi-gesture-tap";
      }
      if (type === "conditions") {
        return "mdi-call-split";
      }
      if (type === "settings") {
        return "mdi-cog";
      }
      return "mdi-help-circle-outline";
    },
    getColor(type) {
      if (type === "dataElements") {
        return "teal";
      }
      if (type === "actions") {
        return "orange";
      }
      if (type === "events") {
        return "blue";
      }
      if (type === "conditions") {
        return "green";
      }
      if (type === "settings") {
        return "light-green";
      }
      return "";
    },
    getScript(m) {
      if (typeof m.script === "function") {
        return m.script.toString();
      }
      return;
    }
  },
  beforeMount() {
    let modules = this.$props.extension.modules;
    let keys = Object.keys(modules);
    let dataChips = [];
    for (let i = 0, l = keys.length; i < l; i++) {
      let path = keys[i];
      let split = path.split("/");
      let type = split[split.length - 2];
      let name =
        modules[path].displayName ||
        split[split.length - 1].replace(".js", "") ||
        "notSet";
      dataChips.push({
        name,
        type,
        icon: this.getIcon(type),
        key: path,
        color: this.getColor(type)
        //data: this.getScript(modules[path]) // not needed?
      });

      /* resolve functions... not really needed!
      if (typeof modules[path].script === "function") {
        modules[path].script = modules[path].script.toString();
      }
      // === */
    }
    let settings = this.$props.extension.settings;
    if (settings) {
      dataChips.push({
        name: "settings",
        type: "settings",
        icon: this.getIcon("settings"),
        key: "settings",
        data: settings,
        color: this.getColor("settings")
      });
    }
    this.chips = dataChips;
  }
};
</script>